import React from "react";

interface TextInputProps {
  title: string;
  required?: boolean;
  onChange?: (t: string) => void;
}
const TextInput = ({
  title,
  required = true,
  onChange,
  ...props
}: TextInputProps) => {
  return (
    <div className=" flex flex-col gap-2">
      <p>{`${title}${required && " *"}`}</p>
      <div className="flex w-full border border-black rounded-lg px-3 py-2 gap-2">
        <input
          type="text"
          className="w-full outline-none text-text-grey"
          onChange={(e) => onChange && onChange(e.target.value)}
          {...props}
        />
      </div>
    </div>
  );
};
export default TextInput;
